import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _e2c39f3c = () => interopDefault(import('../pages/aktie.vue' /* webpackChunkName: "pages/aktie" */))
const _3ce602c0 = () => interopDefault(import('../pages/aktie/_share/index.vue' /* webpackChunkName: "pages/aktie/_share/index" */))
const _17668212 = () => interopDefault(import('../pages/aktie/_share/fundamentaldaten/_tab_id.vue' /* webpackChunkName: "pages/aktie/_share/fundamentaldaten/_tab_id" */))
const _3f42ac79 = () => interopDefault(import('../pages/feedback.vue' /* webpackChunkName: "pages/feedback" */))
const _344835c2 = () => interopDefault(import('../pages/fin-agent/index.vue' /* webpackChunkName: "pages/fin-agent/index" */))
const _443d0bb6 = () => interopDefault(import('../pages/login.vue' /* webpackChunkName: "pages/login" */))
const _55f38dcf = () => interopDefault(import('../pages/maintenance.vue' /* webpackChunkName: "pages/maintenance" */))
const _46c77ccc = () => interopDefault(import('../pages/market-analysis/index.vue' /* webpackChunkName: "pages/market-analysis/index" */))
const _32cf4936 = () => interopDefault(import('../pages/profile.vue' /* webpackChunkName: "pages/profile" */))
const _740c03d2 = () => interopDefault(import('../pages/settings.vue' /* webpackChunkName: "pages/settings" */))
const _29da7fde = () => interopDefault(import('../pages/subscription.vue' /* webpackChunkName: "pages/subscription" */))
const _719af53f = () => interopDefault(import('../pages/user-mgmt.vue' /* webpackChunkName: "pages/user-mgmt" */))
const _064432b1 = () => interopDefault(import('../pages/checkout/success/index.vue' /* webpackChunkName: "pages/checkout/success/index" */))
const _22a0d96e = () => interopDefault(import('../pages/fin-agent/library/index.vue' /* webpackChunkName: "pages/fin-agent/library/index" */))
const _273e6b10 = () => interopDefault(import('../pages/fin-agent/recurring/index.vue' /* webpackChunkName: "pages/fin-agent/recurring/index" */))
const _3795f96c = () => interopDefault(import('../pages/fin-agent/thread.vue' /* webpackChunkName: "pages/fin-agent/thread" */))
const _5f691409 = () => interopDefault(import('../pages/fin-agent/thread/_thread_id/index.vue' /* webpackChunkName: "pages/fin-agent/thread/_thread_id/index" */))
const _376b4604 = () => interopDefault(import('../pages/fin-agent/thread/_thread_id/message.vue' /* webpackChunkName: "pages/fin-agent/thread/_thread_id/message" */))
const _267f5ce1 = () => interopDefault(import('../pages/fin-agent/thread/_thread_id/message/_message_id.vue' /* webpackChunkName: "pages/fin-agent/thread/_thread_id/message/_message_id" */))
const _04c2115d = () => interopDefault(import('../pages/fin-agent/watchlist.vue' /* webpackChunkName: "pages/fin-agent/watchlist" */))
const _75afa05b = () => interopDefault(import('../pages/finance/dashboard.vue' /* webpackChunkName: "pages/finance/dashboard" */))
const _509562f0 = () => interopDefault(import('../pages/finance/dashboard/_tab_id.vue' /* webpackChunkName: "pages/finance/dashboard/_tab_id" */))
const _764d410f = () => interopDefault(import('../pages/finance/portfolio.vue' /* webpackChunkName: "pages/finance/portfolio" */))
const _6ae28052 = () => interopDefault(import('../pages/finance/portfolio/index.vue' /* webpackChunkName: "pages/finance/portfolio/index" */))
const _5fb91434 = () => interopDefault(import('../pages/finance/portfolio/_portfolio_id/_tab_id.vue' /* webpackChunkName: "pages/finance/portfolio/_portfolio_id/_tab_id" */))
const _339b3895 = () => interopDefault(import('../pages/market-analysis/market-data.vue' /* webpackChunkName: "pages/market-analysis/market-data" */))
const _56c475c6 = () => interopDefault(import('../pages/market-analysis/personalized.vue' /* webpackChunkName: "pages/market-analysis/personalized" */))
const _16038c9f = () => interopDefault(import('../pages/checkout/create/_product_id/index.vue' /* webpackChunkName: "pages/checkout/create/_product_id/index" */))
const _732b8db8 = () => interopDefault(import('../pages/fin-agent/library/_snippet_id.vue' /* webpackChunkName: "pages/fin-agent/library/_snippet_id" */))
const _9af12a4c = () => interopDefault(import('../pages/fin-agent/recurring/_recurring_id.vue' /* webpackChunkName: "pages/fin-agent/recurring/_recurring_id" */))
const _6dd2c926 = () => interopDefault(import('../pages/market-analysis/sector-reports/_sector_id.vue' /* webpackChunkName: "pages/market-analysis/sector-reports/_sector_id" */))
const _31acb1f2 = () => interopDefault(import('../pages/market-analysis/_date.vue' /* webpackChunkName: "pages/market-analysis/_date" */))
const _3234f96c = () => interopDefault(import('../pages/checkout/_.vue' /* webpackChunkName: "pages/checkout/_" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/de/aktie/",
    component: _e2c39f3c,
    pathToRegexpOptions: {"strict":true},
    name: "aktie",
    children: [{
      path: ":share?/",
      component: _3ce602c0,
      pathToRegexpOptions: {"strict":true},
      name: "aktie-share"
    }, {
      path: ":share?/fundamentaldaten/:tab_id?/",
      component: _17668212,
      pathToRegexpOptions: {"strict":true},
      name: "aktie-share-fundamentaldaten-tab_id"
    }]
  }, {
    path: "/de/virtual/aktie/",
    component: _e2c39f3c,
    pathToRegexpOptions: {"strict":true},
    name: "aktie",
    children: [{
      path: ":share?/",
      component: _3ce602c0,
      pathToRegexpOptions: {"strict":true},
      name: "virtual-aktie-share"
    }, {
      path: ":share?/fundamentaldaten/:tab_id?/",
      component: _17668212,
      pathToRegexpOptions: {"strict":true},
      name: "virtual-aktie-share-fundamentaldaten-tab_id"
    }]
  }, {
    path: "/en/stock/",
    component: _e2c39f3c,
    pathToRegexpOptions: {"strict":true},
    name: "stock",
    children: [{
      path: ":share?/",
      component: _3ce602c0,
      pathToRegexpOptions: {"strict":true},
      name: "stock-share"
    }, {
      path: ":share?/fundamentaldata/:tab_id?/",
      component: _17668212,
      pathToRegexpOptions: {"strict":true},
      name: "stock-share-fundamentaldata-tab_id"
    }]
  }, {
    path: "/en/sandbox/stock/",
    component: _e2c39f3c,
    pathToRegexpOptions: {"strict":true},
    name: "stock",
    children: [{
      path: ":share?/",
      component: _3ce602c0,
      pathToRegexpOptions: {"strict":true},
      name: "sandbox-stock-share"
    }, {
      path: ":share?/fundamentaldata/:tab_id?/",
      component: _17668212,
      pathToRegexpOptions: {"strict":true},
      name: "sandbox-stock-share-fundamentaldata-tab_id"
    }]
  }, {
    path: "/es/compartir/",
    component: _e2c39f3c,
    pathToRegexpOptions: {"strict":true},
    name: "compartir",
    children: [{
      path: ":share?/",
      component: _3ce602c0,
      pathToRegexpOptions: {"strict":true},
      name: "compartir-accion"
    }, {
      path: ":share?/datos-fundamentales/:tab_id?/",
      component: _17668212,
      pathToRegexpOptions: {"strict":true},
      name: "compartir-accion-datos-fundamentales-tab_id"
    }]
  }, {
    path: "/es/salvadera/compartir/",
    component: _e2c39f3c,
    pathToRegexpOptions: {"strict":true},
    name: "compartir",
    children: [{
      path: ":share?/",
      component: _3ce602c0,
      pathToRegexpOptions: {"strict":true},
      name: "salvadera-compartir-accion"
    }, {
      path: ":share?/datos-fundamentales/:tab_id?/",
      component: _17668212,
      pathToRegexpOptions: {"strict":true},
      name: "salvadera-compartir-accion-datos-fundamentales-tab_id"
    }]
  }, {
    path: "/fr/partager/",
    component: _e2c39f3c,
    pathToRegexpOptions: {"strict":true},
    name: "partager",
    children: [{
      path: ":share?/",
      component: _3ce602c0,
      pathToRegexpOptions: {"strict":true},
      name: "partager-action"
    }, {
      path: ":share?/donnees-fondamentales/:tab_id?/",
      component: _17668212,
      pathToRegexpOptions: {"strict":true},
      name: "partager-action-donnees-fondamentales-tab_id"
    }]
  }, {
    path: "/fr/virtuel/partager/",
    component: _e2c39f3c,
    pathToRegexpOptions: {"strict":true},
    name: "partager",
    children: [{
      path: ":share?/",
      component: _3ce602c0,
      pathToRegexpOptions: {"strict":true},
      name: "virtuel-partager-action"
    }, {
      path: ":share?/donnees-fondamentales/:tab_id?/",
      component: _17668212,
      pathToRegexpOptions: {"strict":true},
      name: "virtuel-partager-action-donnees-fondamentales-tab_id"
    }]
  }, {
    path: "/de/feedback/",
    component: _3f42ac79,
    pathToRegexpOptions: {"strict":true},
    name: "feedback"
  }, {
    path: "/en/feedback/",
    component: _3f42ac79,
    pathToRegexpOptions: {"strict":true},
    name: "feedback"
  }, {
    path: "/es/retroalimentacion/",
    component: _3f42ac79,
    pathToRegexpOptions: {"strict":true},
    name: "retroalimentacion"
  }, {
    path: "/fr/retour/",
    component: _3f42ac79,
    pathToRegexpOptions: {"strict":true},
    name: "retour"
  }, {
    path: "/de/fin-agent/",
    component: _344835c2,
    pathToRegexpOptions: {"strict":true},
    name: "fin-agent"
  }, {
    path: "/en/fin-agent/",
    component: _344835c2,
    pathToRegexpOptions: {"strict":true},
    name: "fin-agent"
  }, {
    path: "/es/fin-agent/",
    component: _344835c2,
    pathToRegexpOptions: {"strict":true},
    name: "fin-agent"
  }, {
    path: "/fr/fin-agent/",
    component: _344835c2,
    pathToRegexpOptions: {"strict":true},
    name: "fin-agent"
  }, {
    path: "/de/anmelden/",
    component: _443d0bb6,
    pathToRegexpOptions: {"strict":true},
    name: "anmelden"
  }, {
    path: "/en/login/",
    component: _443d0bb6,
    pathToRegexpOptions: {"strict":true},
    name: "login"
  }, {
    path: "/es/acceso/",
    component: _443d0bb6,
    pathToRegexpOptions: {"strict":true},
    name: "acceso"
  }, {
    path: "/fr/se-connecter/",
    component: _443d0bb6,
    pathToRegexpOptions: {"strict":true},
    name: "se-connecter"
  }, {
    path: "/de/wartung/",
    component: _55f38dcf,
    pathToRegexpOptions: {"strict":true},
    name: "wartung"
  }, {
    path: "/en/maintenance/",
    component: _55f38dcf,
    pathToRegexpOptions: {"strict":true},
    name: "maintenance"
  }, {
    path: "/es/mantenimiento/",
    component: _55f38dcf,
    pathToRegexpOptions: {"strict":true},
    name: "mantenimiento"
  }, {
    path: "/fr/maintenance/",
    component: _55f38dcf,
    pathToRegexpOptions: {"strict":true},
    name: "maintenance"
  }, {
    path: "/de/marktanalyse/",
    component: _46c77ccc,
    pathToRegexpOptions: {"strict":true},
    name: "market-analysis"
  }, {
    path: "/en/market-analysis/",
    component: _46c77ccc,
    pathToRegexpOptions: {"strict":true},
    name: "market-analysis"
  }, {
    path: "/es/analisis-de-mercado/",
    component: _46c77ccc,
    pathToRegexpOptions: {"strict":true},
    name: "market-analysis"
  }, {
    path: "/fr/analyse-de-marche/",
    component: _46c77ccc,
    pathToRegexpOptions: {"strict":true},
    name: "market-analysis"
  }, {
    path: "/de/profil/",
    component: _32cf4936,
    pathToRegexpOptions: {"strict":true},
    name: "profil"
  }, {
    path: "/en/profile/",
    component: _32cf4936,
    pathToRegexpOptions: {"strict":true},
    name: "profile"
  }, {
    path: "/es/perfil/",
    component: _32cf4936,
    pathToRegexpOptions: {"strict":true},
    name: "perfil"
  }, {
    path: "/fr/profil/",
    component: _32cf4936,
    pathToRegexpOptions: {"strict":true},
    name: "profil"
  }, {
    path: "/de/einstellungen/",
    component: _740c03d2,
    pathToRegexpOptions: {"strict":true},
    name: "einstellungen"
  }, {
    path: "/en/settings/",
    component: _740c03d2,
    pathToRegexpOptions: {"strict":true},
    name: "settings"
  }, {
    path: "/es/configuracion/",
    component: _740c03d2,
    pathToRegexpOptions: {"strict":true},
    name: "configuracion"
  }, {
    path: "/fr/parametres/",
    component: _740c03d2,
    pathToRegexpOptions: {"strict":true},
    name: "parametres"
  }, {
    path: "/de/abo/",
    component: _29da7fde,
    pathToRegexpOptions: {"strict":true},
    name: "abo"
  }, {
    path: "/en/subscription/",
    component: _29da7fde,
    pathToRegexpOptions: {"strict":true},
    name: "subscription"
  }, {
    path: "/es/suscripcion/",
    component: _29da7fde,
    pathToRegexpOptions: {"strict":true},
    name: "suscripcion"
  }, {
    path: "/fr/abonnement/",
    component: _29da7fde,
    pathToRegexpOptions: {"strict":true},
    name: "abonnement"
  }, {
    path: "/de/user-mgmt/",
    component: _719af53f,
    pathToRegexpOptions: {"strict":true},
    name: "benutzer-mgmt"
  }, {
    path: "/en/user-mgmt/",
    component: _719af53f,
    pathToRegexpOptions: {"strict":true},
    name: "user-mgmt"
  }, {
    path: "/es/user-mgmt/",
    component: _719af53f,
    pathToRegexpOptions: {"strict":true},
    name: "usuario-mgmt"
  }, {
    path: "/fr/user-mgmt/",
    component: _719af53f,
    pathToRegexpOptions: {"strict":true},
    name: "utilisateur-mgmt"
  }, {
    path: "/de/kasse/erfolg/",
    component: _064432b1,
    pathToRegexpOptions: {"strict":true},
    name: "kasse-erfolg"
  }, {
    path: "/en/checkout/success/",
    component: _064432b1,
    pathToRegexpOptions: {"strict":true},
    name: "checkout-success"
  }, {
    path: "/es/caja/exito/",
    component: _064432b1,
    pathToRegexpOptions: {"strict":true},
    name: "caja-exito"
  }, {
    path: "/fr/caisse/succes/",
    component: _064432b1,
    pathToRegexpOptions: {"strict":true},
    name: "caisse-succes"
  }, {
    path: "/de/fin-agent/bibliothek/",
    component: _22a0d96e,
    pathToRegexpOptions: {"strict":true},
    name: "fin-agent-bibliothek"
  }, {
    path: "/en/fin-agent/library/",
    component: _22a0d96e,
    pathToRegexpOptions: {"strict":true},
    name: "fin-agent-library"
  }, {
    path: "/es/fin-agent/biblioteca/",
    component: _22a0d96e,
    pathToRegexpOptions: {"strict":true},
    name: "fin-agent-biblioteca"
  }, {
    path: "/fr/fin-agent/bibliotheque/",
    component: _22a0d96e,
    pathToRegexpOptions: {"strict":true},
    name: "fin-agent-bibliotheque"
  }, {
    path: "/de/fin-agent/wiederkehrend/",
    component: _273e6b10,
    pathToRegexpOptions: {"strict":true},
    name: "fin-agent-wiederkehrend"
  }, {
    path: "/en/fin-agent/recurring/",
    component: _273e6b10,
    pathToRegexpOptions: {"strict":true},
    name: "fin-agent-recurring"
  }, {
    path: "/es/fin-agent/recurrencia/",
    component: _273e6b10,
    pathToRegexpOptions: {"strict":true},
    name: "fin-agent-recurrencia"
  }, {
    path: "/fr/fin-agent/recurrence/",
    component: _273e6b10,
    pathToRegexpOptions: {"strict":true},
    name: "fin-agent-recurrence"
  }, {
    path: "/de/fin-agent/thread/",
    component: _3795f96c,
    pathToRegexpOptions: {"strict":true},
    name: "fin-agent-thread",
    children: [{
      path: ":thread_id?/",
      component: _5f691409,
      pathToRegexpOptions: {"strict":true},
      name: "fin-agent-thread-thread_id"
    }, {
      path: ":thread_id?/nachricht/",
      component: _376b4604,
      pathToRegexpOptions: {"strict":true},
      name: "fin-agent-thread-thread_id-nachricht",
      children: [{
        path: ":message_id?/",
        component: _267f5ce1,
        pathToRegexpOptions: {"strict":true},
        name: "fin-agent-thread-thread_id-nachricht-message_id"
      }]
    }]
  }, {
    path: "/en/fin-agent/thread/",
    component: _3795f96c,
    pathToRegexpOptions: {"strict":true},
    name: "fin-agent-thread",
    children: [{
      path: ":thread_id?/",
      component: _5f691409,
      pathToRegexpOptions: {"strict":true},
      name: "fin-agent-thread-thread_id"
    }, {
      path: ":thread_id?/message/",
      component: _376b4604,
      pathToRegexpOptions: {"strict":true},
      name: "fin-agent-thread-thread_id-message",
      children: [{
        path: ":message_id?/",
        component: _267f5ce1,
        pathToRegexpOptions: {"strict":true},
        name: "fin-agent-thread-thread_id-message-message_id"
      }]
    }]
  }, {
    path: "/es/fin-agent/hilo/",
    component: _3795f96c,
    pathToRegexpOptions: {"strict":true},
    name: "fin-agent-hilo",
    children: [{
      path: ":thread_id?/",
      component: _5f691409,
      pathToRegexpOptions: {"strict":true},
      name: "fin-agent-hilo-thread_id"
    }, {
      path: ":thread_id?/mensaje/",
      component: _376b4604,
      pathToRegexpOptions: {"strict":true},
      name: "fin-agent-hilo-thread_id-mensaje",
      children: [{
        path: ":message_id?/",
        component: _267f5ce1,
        pathToRegexpOptions: {"strict":true},
        name: "fin-agent-hilo-thread_id-mensaje-message_id"
      }]
    }]
  }, {
    path: "/fr/fin-agent/fil/",
    component: _3795f96c,
    pathToRegexpOptions: {"strict":true},
    name: "fin-agent-fil",
    children: [{
      path: ":thread_id?/",
      component: _5f691409,
      pathToRegexpOptions: {"strict":true},
      name: "fin-agent-fil-thread_id"
    }, {
      path: ":thread_id?/mensaje/",
      component: _376b4604,
      pathToRegexpOptions: {"strict":true},
      name: "fin-agent-fil-thread_id-mensaje",
      children: [{
        path: ":message_id?/",
        component: _267f5ce1,
        pathToRegexpOptions: {"strict":true},
        name: "fin-agent-fil-thread_id-mensaje-message_id"
      }]
    }]
  }, {
    path: "/de/fin-agent/watchlist/",
    component: _04c2115d,
    pathToRegexpOptions: {"strict":true},
    name: "fin-agent-watchlist"
  }, {
    path: "/en/fin-agent/watchlist/",
    component: _04c2115d,
    pathToRegexpOptions: {"strict":true},
    name: "fin-agent-watchlist"
  }, {
    path: "/es/fin-agent/lista-de-vigilancia/",
    component: _04c2115d,
    pathToRegexpOptions: {"strict":true},
    name: "fin-agent-lista-de-vigilancia"
  }, {
    path: "/fr/fin-agent/liste-de-surveillance/",
    component: _04c2115d,
    pathToRegexpOptions: {"strict":true},
    name: "fin-agent-liste-de-surveillance"
  }, {
    path: "/de/finanzen/uebersicht/",
    component: _75afa05b,
    pathToRegexpOptions: {"strict":true},
    name: "finanzen-uebersicht",
    children: [{
      path: ":tab_id?/",
      component: _509562f0,
      pathToRegexpOptions: {"strict":true},
      name: "finanzen-uebersicht-tab_id"
    }]
  }, {
    path: "/de/virtual/uebersicht/",
    component: _75afa05b,
    pathToRegexpOptions: {"strict":true},
    name: "virtual-uebersicht",
    children: [{
      path: ":tab_id?/",
      component: _509562f0,
      pathToRegexpOptions: {"strict":true},
      name: "virtual-uebersicht-tab_id"
    }]
  }, {
    path: "/en/finance/dashboard/",
    component: _75afa05b,
    pathToRegexpOptions: {"strict":true},
    name: "finance-dashboard",
    children: [{
      path: ":tab_id?/",
      component: _509562f0,
      pathToRegexpOptions: {"strict":true},
      name: "finance-dashboard-tab_id"
    }]
  }, {
    path: "/en/sandbox/dashboard/",
    component: _75afa05b,
    pathToRegexpOptions: {"strict":true},
    name: "sandbox-dashboard",
    children: [{
      path: ":tab_id?/",
      component: _509562f0,
      pathToRegexpOptions: {"strict":true},
      name: "sandbox-dashboard-tab_id"
    }]
  }, {
    path: "/es/finanzas/tablero/",
    component: _75afa05b,
    pathToRegexpOptions: {"strict":true},
    name: "finanzas-tablero",
    children: [{
      path: ":tab_id?/",
      component: _509562f0,
      pathToRegexpOptions: {"strict":true},
      name: "finanzas-tablero-tab_id"
    }]
  }, {
    path: "/es/salvadera/tablero/",
    component: _75afa05b,
    pathToRegexpOptions: {"strict":true},
    name: "salvadera-tablero",
    children: [{
      path: ":tab_id?/",
      component: _509562f0,
      pathToRegexpOptions: {"strict":true},
      name: "salvadera-tablero-tab_id"
    }]
  }, {
    path: "/fr/finance/tableau-de-bord/",
    component: _75afa05b,
    pathToRegexpOptions: {"strict":true},
    name: "finance-tableau-de-bord",
    children: [{
      path: ":tab_id?/",
      component: _509562f0,
      pathToRegexpOptions: {"strict":true},
      name: "finance-tableau-de-bord-tab_id"
    }]
  }, {
    path: "/fr/virtuel/tableau-de-bord/",
    component: _75afa05b,
    pathToRegexpOptions: {"strict":true},
    name: "virtuel-tableau-de-bord",
    children: [{
      path: ":tab_id?/",
      component: _509562f0,
      pathToRegexpOptions: {"strict":true},
      name: "virtuel-tableau-de-bord-tab_id"
    }]
  }, {
    path: "/de/finanzen/portfolio/",
    component: _764d410f,
    pathToRegexpOptions: {"strict":true},
    children: [{
      path: "/de",
      component: _6ae28052,
      pathToRegexpOptions: {"strict":true},
      name: "finanzen-portfolio"
    }, {
      path: ":portfolio_id/:tab_id?/",
      component: _5fb91434,
      pathToRegexpOptions: {"strict":true},
      name: "finanzen-portfolio-portfolio_id-tab_id"
    }]
  }, {
    path: "/de/virtual/portfolio/",
    component: _764d410f,
    pathToRegexpOptions: {"strict":true},
    children: [{
      path: "/de",
      component: _6ae28052,
      pathToRegexpOptions: {"strict":true},
      name: "virtual-portfolio"
    }, {
      path: ":portfolio_id/:tab_id?/",
      component: _5fb91434,
      pathToRegexpOptions: {"strict":true},
      name: "virtual-portfolio-portfolio_id-tab_id"
    }]
  }, {
    path: "/en/finance/portfolio/",
    component: _764d410f,
    pathToRegexpOptions: {"strict":true},
    children: [{
      path: "/en",
      component: _6ae28052,
      pathToRegexpOptions: {"strict":true},
      name: "finance-portfolio"
    }, {
      path: ":portfolio_id/:tab_id?/",
      component: _5fb91434,
      pathToRegexpOptions: {"strict":true},
      name: "finance-portfolio-portfolio_id-tab_id"
    }]
  }, {
    path: "/en/sandbox/portfolio/",
    component: _764d410f,
    pathToRegexpOptions: {"strict":true},
    children: [{
      path: "/en",
      component: _6ae28052,
      pathToRegexpOptions: {"strict":true},
      name: "sandbox-portfolio"
    }, {
      path: ":portfolio_id/:tab_id?/",
      component: _5fb91434,
      pathToRegexpOptions: {"strict":true},
      name: "sandbox-portfolio-portfolio_id-tab_id"
    }]
  }, {
    path: "/es/finanzas/portafolio/",
    component: _764d410f,
    pathToRegexpOptions: {"strict":true},
    children: [{
      path: "/es",
      component: _6ae28052,
      pathToRegexpOptions: {"strict":true},
      name: "finanzas-portafolio"
    }, {
      path: ":portfolio_id/:tab_id?/",
      component: _5fb91434,
      pathToRegexpOptions: {"strict":true},
      name: "finanzas-portafolio-portfolio_id-tab_id"
    }]
  }, {
    path: "/es/salvadera/portafolio/",
    component: _764d410f,
    pathToRegexpOptions: {"strict":true},
    children: [{
      path: "/es",
      component: _6ae28052,
      pathToRegexpOptions: {"strict":true},
      name: "salvadera-portafolio"
    }, {
      path: ":portfolio_id/:tab_id?/",
      component: _5fb91434,
      pathToRegexpOptions: {"strict":true},
      name: "salvadera-portafolio-portfolio_id-tab_id"
    }]
  }, {
    path: "/fr/finance/portefeuille/",
    component: _764d410f,
    pathToRegexpOptions: {"strict":true},
    children: [{
      path: "/fr",
      component: _6ae28052,
      pathToRegexpOptions: {"strict":true},
      name: "finance-portefeuille"
    }, {
      path: ":portfolio_id/:tab_id?/",
      component: _5fb91434,
      pathToRegexpOptions: {"strict":true},
      name: "finance-portefeuille-portfolio_id-tab_id"
    }]
  }, {
    path: "/fr/virtuel/portefeuille/",
    component: _764d410f,
    pathToRegexpOptions: {"strict":true},
    children: [{
      path: "/fr",
      component: _6ae28052,
      pathToRegexpOptions: {"strict":true},
      name: "virtuel-portefeuille"
    }, {
      path: ":portfolio_id/:tab_id?/",
      component: _5fb91434,
      pathToRegexpOptions: {"strict":true},
      name: "virtuel-portefeuille-portfolio_id-tab_id"
    }]
  }, {
    path: "/de/marktanalyse/marktdaten/",
    component: _339b3895,
    pathToRegexpOptions: {"strict":true},
    name: "market-analysis-market-data"
  }, {
    path: "/en/market-analysis/market-data/",
    component: _339b3895,
    pathToRegexpOptions: {"strict":true},
    name: "market-analysis-market-data"
  }, {
    path: "/es/analisis-de-mercado/datos-de-mercado/",
    component: _339b3895,
    pathToRegexpOptions: {"strict":true},
    name: "market-analysis-market-data"
  }, {
    path: "/fr/analyse-de-marche/market-data/",
    component: _339b3895,
    pathToRegexpOptions: {"strict":true},
    name: "market-analysis-market-données-marché"
  }, {
    path: "/de/marktanalyse/personalisiert/",
    component: _56c475c6,
    pathToRegexpOptions: {"strict":true},
    name: "market-analysis-personalisiert"
  }, {
    path: "/en/market-analysis/personalized/",
    component: _56c475c6,
    pathToRegexpOptions: {"strict":true},
    name: "market-analysis-personalized"
  }, {
    path: "/es/analisis-de-mercado/personalizado/",
    component: _56c475c6,
    pathToRegexpOptions: {"strict":true},
    name: "market-analysis-personalizado"
  }, {
    path: "/fr/analyse-de-marche/personnalise/",
    component: _56c475c6,
    pathToRegexpOptions: {"strict":true},
    name: "market-analysis-personnalise"
  }, {
    path: "/de/kasse/erstellen/:product_id?/",
    component: _16038c9f,
    pathToRegexpOptions: {"strict":true},
    name: "kasse-erstellen-product_id"
  }, {
    path: "/en/checkout/create/:product_id?/",
    component: _16038c9f,
    pathToRegexpOptions: {"strict":true},
    name: "checkout-create-product_id"
  }, {
    path: "/es/caja/crear/:product_id?/",
    component: _16038c9f,
    pathToRegexpOptions: {"strict":true},
    name: "caja-crear-product_id"
  }, {
    path: "/fr/caisse/creer/:product_id?/",
    component: _16038c9f,
    pathToRegexpOptions: {"strict":true},
    name: "caisse-creer-product_id"
  }, {
    path: "/de/fin-agent/bibliothek/:snippet_id/",
    component: _732b8db8,
    pathToRegexpOptions: {"strict":true},
    name: "fin-agent-bibliothek-snippet_id"
  }, {
    path: "/en/fin-agent/library/:snippet_id/",
    component: _732b8db8,
    pathToRegexpOptions: {"strict":true},
    name: "fin-agent-library-snippet_id"
  }, {
    path: "/es/fin-agent/biblioteca/:snippet_id/",
    component: _732b8db8,
    pathToRegexpOptions: {"strict":true},
    name: "fin-agent-biblioteca-snippet_id"
  }, {
    path: "/fr/fin-agent/bibliotheque/:snippet_id/",
    component: _732b8db8,
    pathToRegexpOptions: {"strict":true},
    name: "fin-agent-bibliotheque-snippet_id"
  }, {
    path: "/de/fin-agent/wiederkehrend/:recurring_id/",
    component: _9af12a4c,
    pathToRegexpOptions: {"strict":true},
    name: "fin-agent-wiederkehrend-recurring_id"
  }, {
    path: "/en/fin-agent/recurring/:recurring_id/",
    component: _9af12a4c,
    pathToRegexpOptions: {"strict":true},
    name: "fin-agent-recurring-recurring_id"
  }, {
    path: "/es/fin-agent/recurrencia/:recurring_id/",
    component: _9af12a4c,
    pathToRegexpOptions: {"strict":true},
    name: "fin-agent-recurrencia-recurring_id"
  }, {
    path: "/fr/fin-agent/recurrence/:recurring_id/",
    component: _9af12a4c,
    pathToRegexpOptions: {"strict":true},
    name: "fin-agent-recurrence-recurring_id"
  }, {
    path: "/de/marktanalyse/sektoren/:sector_id/",
    component: _6dd2c926,
    pathToRegexpOptions: {"strict":true},
    name: "market-analysis-sector-reports-sector_id"
  }, {
    path: "/en/market-analysis/sector-reports/:sector_id/",
    component: _6dd2c926,
    pathToRegexpOptions: {"strict":true},
    name: "market-analysis-sector-reports-sector_id"
  }, {
    path: "/es/analisis-de-mercado/informes-sectoriales/:sector_id/",
    component: _6dd2c926,
    pathToRegexpOptions: {"strict":true},
    name: "market-analysis-sector-reports-sector_id"
  }, {
    path: "/fr/analyse-de-marche/sector-reports/:sector_id/",
    component: _6dd2c926,
    pathToRegexpOptions: {"strict":true},
    name: "market-analysis-rapports-sectoriels-reports-sector_id"
  }, {
    path: "/de/marktanalyse/:date?/",
    component: _31acb1f2,
    pathToRegexpOptions: {"strict":true},
    name: "market-analysis-date"
  }, {
    path: "/en/market-analysis/:date?/",
    component: _31acb1f2,
    pathToRegexpOptions: {"strict":true},
    name: "market-analysis-date"
  }, {
    path: "/es/analisis-de-mercado/:date?/",
    component: _31acb1f2,
    pathToRegexpOptions: {"strict":true},
    name: "market-analysis-date"
  }, {
    path: "/fr/analyse-de-marche/:date?/",
    component: _31acb1f2,
    pathToRegexpOptions: {"strict":true},
    name: "market-analysis-date"
  }, {
    path: "/checkout/*",
    component: _3234f96c,
    pathToRegexpOptions: {"strict":true},
    name: "checkout-all"
  }, {
    path: "/de/kasse/*",
    component: _3234f96c,
    pathToRegexpOptions: {"strict":true},
    name: "kasse-all"
  }, {
    path: "/en/checkout/*",
    component: _3234f96c,
    pathToRegexpOptions: {"strict":true},
    name: "checkout-all"
  }, {
    path: "/es/caja/*",
    component: _3234f96c,
    pathToRegexpOptions: {"strict":true},
    name: "caja-all"
  }, {
    path: "/fr/caisse/*",
    component: _3234f96c,
    pathToRegexpOptions: {"strict":true},
    name: "caisse-all"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
